import { Card, Divider, Grid2 as Grid, Typography } from '@mui/material';

export default function PerformanceCard({
  avatar,
  title,
  value,
  valueMuted = false,
  helperText,
  icon,
  footerTitle,
  footerDescription,
}) {
  return (
    <Card
      elevation={2}
      sx={{
        borderRadius: 2,
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Grid container spacing={1} sx={{ flexGrow: 1 }}>
        <Grid container size={12} spacing={1} alignItems="center">
          <Grid size="auto" sx={{ display: 'flex', alignItems: 'center' }}>
            {avatar}
          </Grid>
          <Grid size="grow">
            <Typography
              variant="subtitle2"
              sx={{
                textTransform: 'none',
                fontWeight: 500,
                '&::first-letter': {
                  textTransform: 'uppercase',
                },
              }}
            >
              {title}
            </Typography>
          </Grid>
        </Grid>
        {helperText && (
          <Grid size={12}>
            <Typography variant="caption" color="text.secondary">
              {helperText}
            </Typography>
          </Grid>
        )}

        <Grid
          container
          size={12}
          justifyContent="center"
          alignItems="center"
          spacing={1}
          sx={{
            minHeight: valueMuted ? 44 : 'auto',
          }}
        >
          {icon && <Grid size="auto">{icon}</Grid>}
          <Grid size="auto">
            <Typography
              variant="h5"
              sx={{
                textTransform: 'none',
                fontWeight: valueMuted ? 400 : 500,
                color: valueMuted ? 'text.disabled' : 'text.primary',
                '&::first-letter': {
                  textTransform: 'uppercase',
                },
              }}
            >
              {value}
            </Typography>
          </Grid>
        </Grid>

        <Divider />

        <Grid
          container
          justifyContent="center"
          alignItems="center"
          size={12}
          spacing={1}
        >
          {footerTitle && (
            <Grid size="auto">
              <Typography variant="caption">{footerTitle}</Typography>
            </Grid>
          )}
          <Grid size="auto">
            <Typography variant="caption">{footerDescription}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
}
